export default{
    title: 'Ημερολόγιο',
    sync: 'Συγχρονισμός Calendar',
    settings: 'Ρυθμίσεις',
    stop: 'Διακοπή συγχρονισμού',
    activeSync: 'Ενεργός συγχρονισμός με',
    syncPaused: 'Ο συγχρονισμός έχει σταματήσει. Παρακαλώ ξανα-ενεργοποιήστε τα δικαιώματα πρόσβασης στο calendar κάνοντας κλικ παρακάτω.',
    notFunctioning: 'Εάν ο συγχρονισμός δεν λειτουργεί,',
    googleNoEdit: 'Αυτό το γεγονός αλλάζει μόνο από το Google Calendar.',

    edit:'Επεξεργασία ραντεβού',
    add: 'Προσθήκη νέου ραντεβού',
    cancelled: 'Ακυρωμένο ραντεβού'
}
